export const removeSpaces = (str: string): string => {
  return str.replace(/\s/g, '');
};

export const containsNonLatinCodepoints = (s: string) => {
  return /[^\u0000-\u00ff]/.test(s);
};

export const cleanTitle = (title: string, ID: string) => {
  if (containsNonLatinCodepoints(title)) {
    return title.split(' ', -1).slice(1).join(' ');
  }
  if (title.indexOf(`[${ID}]`) !== -1) {
    const titleWithoutID = title.split('] ')[1];
    if (titleWithoutID !== undefined) {
      return titleWithoutID.toUpperCase();
    }
  }
  return title.toUpperCase();
};
